import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvConfig } from '@core/config';
import { isInternalApi } from '@core/utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { envelopeKey, hasPagination, isInEnvelope, unwrapFromEnvelope } from './entity-keys';

@Injectable()
export class ApiConfigInterceptor implements HttpInterceptor {
  constructor(private env: EnvConfig) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const LANGUAGE_STORAGE_KEY = 'wai_user_language';
    const initialTheme = JSON.parse(localStorage.getItem('initialThemeParams') || '{}');
    const activeTheme = JSON.parse(localStorage.getItem('activeTheme') || '{}');

    const isThemeSame = initialTheme?.uid === activeTheme?.uid;
    const partnerDomainId = initialTheme?.uid || '';
    const selectedPartnerId = activeTheme?.uid || '';
    const currentLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);

    if (isInternalApi(request.url, this.env.apiUrl)) {
      const finalUrl = `${this.env.apiUrl}/${request.url}`;

      // Build headers safely - ensure no null/undefined values
      // Always set Accept header first
      let headers = request.headers.set('Accept', 'application/json');

      // Set X-Partner-Domain header (can be empty string, but not null/undefined)
      headers = headers.set('X-Partner-Domain', partnerDomainId || '');

      // Set X-Selected-Partner header (empty string when themes match, otherwise selectedPartnerId or empty)
      const selectedPartnerValue = isThemeSame ? '' : selectedPartnerId || '';
      headers = headers.set('X-Selected-Partner', selectedPartnerValue);

      // Set X-Language header only if language exists (null/undefined should not be set)
      if (currentLanguage != null) {
        headers = headers.set('X-Language', currentLanguage);
      }

      request = request.clone({
        // NOTE: backend requires 'application/json' header for all resources, including images
        headers: headers,
        url: finalUrl,
      });
    } else if (request.url.includes('accounts/theme')) {
      console.warn('[ApiConfigInterceptor] Theme endpoint NOT recognized as internal API:', {
        url: request.url,
        apiUrl: this.env.apiUrl,
      });
    }

    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          // Safely check pagination and envelope - handle null/undefined bodies
          if (event.body != null && hasPagination(event.body)) {
            return event;
          }
          if (event.body != null && isInEnvelope(event.body, envelopeKey)) {
            try {
              event = event.clone({
                body: unwrapFromEnvelope(event.body, envelopeKey),
              });
            } catch (e) {
              console.warn('⚠️ Failed to unwrap envelope:', e);
            }
          }
        }

        return event;
      }),
    );
  }
}
